<template>
  <div class="inline-block mx-1 my-1 p-2 border border-theme-1 rounded">
    <span class="text-xs text-theme-1 font-medium">{{
      `${title}: ${text}`
    }}</span>
  </div>
</template>

<script setup>
const props = defineProps({
  title: String,
  text: String,
});
</script>
